<template>
  <h3>个股雪球</h3>
  <SearchForm @submit="fetchData" :isSubmitting="isSubmitting" />


  <el-collapse v-model="activeCollapse">
    <!-- 类型筛选 -->
    <el-collapse-item title="结构类型" name="structure">
      <el-radio-group v-model="selectedStructure" @change="applyFilter" class="button-group">
        <el-radio-button
          v-for="option in options"
          :key="option.value"
          :label="option.value"
          class="mobile-radio"
        >
          {{ option.label }}
        </el-radio-button>
      </el-radio-group>
    </el-collapse-item>

    <!-- 金额筛选 -->
    <el-collapse-item title="投资金额" name="amount" style="display: none;">
      <el-radio-group
        v-model="selectedStructure_amount"
        @change="applyPrice"
        class="button-group"
      >
        <el-radio-button
          v-for="option in total_principal_options"
          :key="option.value"
          :label="option.value"
          class="mobile-radio"
        >
          {{ option.label }}
        </el-radio-button>
      </el-radio-group>
    </el-collapse-item>

 <!-- 券商筛选 -->
    <el-collapse-item title="期权公司" name="brokerage" style="display: none;">
      <el-radio-group
        v-model="selectedBrokerage"
        @change="applyBrokerageFilter"
        class="mobile-radio-group"
      >
        <el-radio-button
          v-for="item in brokerage_options"
          :key="item.value"
          :label="item.value"
          class="mobile-radio"
        >
          {{ item.label }}
        </el-radio-button>
      </el-radio-group>
    </el-collapse-item>


    <!-- 时间筛选 -->
    <el-collapse-item title="期权时长" name="times">
      <el-radio-group
        v-model="selectedTimes"
        @change="applyTimesFilter"
        class="button-group"
      >
        <el-radio-button
          v-for="option in times_options"
          :key="option.value"
          :label="option.value"
          class="mobile-radio"
        >
          {{ option.label }}
        </el-radio-button>
      </el-radio-group>
    </el-collapse-item>
  </el-collapse>

  <!-- 表格区域 -->
  <div v-if="filteredTableData.length > 0" class="table-container">
    <StockTableXQ :tableData="filteredTableData" :now_str="selectedStructure" />
  </div>
</template>
<script>
import axios from 'axios';
import SearchForm from '@/components/SearchForm.vue';
import StockTableXQ from '@/components/StockTableXQ.vue';

export default {
  name: 'StockSearchFormPageXQ',
  components: {
    SearchForm,
    StockTableXQ
  },
  data() {
    return {
      isSubmitting: false,
      searchQuery: '',
      warning: '',
      tableData: [],
      originalTableData: [],  // 添加原始数据副本
      selectedStructure: '不追保雪球',
      selectedStructure_amount: '1',
      selectedBrokerage: 'all',  // 初始化为默认值
      selectedTimes:'6M',
      options: [
        { value: '不追保雪球', label: '不追保雪球' },
        { value: '追保雪球', label: '追保雪球' },
        { value: '折价建仓雪球', label: '折价建仓雪球' },
      ],
      total_principal_options: [
        { value: '1', label: '100w' },
        { value: '2', label: '200w' },
        { value: '3', label: '300w' },
        { value: '4', label: '400w' },
        { value: '5', label: '500w' }
      ],
      brokerage_options: [
        { value: 'all', label: '全部' },
        { value: '银河_雪球', label: '银河_雪球' },
        { value: '中信_雪球', label: '中信_雪球' },
        { value: '浙期_雪球', label: '浙期_雪球' },
        { value: '国君_雪球', label: '国君_雪球' },
        { value: '中金_雪球', label: '中金_雪球' }
      ],
       times_options: [
        { value: '6M', label: '6M' },
        { value: '12M', label: '12M' },
      ],
      total_principal: '1',  // 初始化为默认值
      total_principal_label: '100w',  // 用于存储 label 值
      containerDisplay:false,
      activeCollapse: ['structure','times'], // 默认展开的筛选条件
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRecords / this.perPage);
    },

    filteredTableData() {
            let filteredData = this.tableData;
            // 根据类型筛选
            if (this.selectedStructure) {
              const startIndex = filteredData.findIndex(
                (item) => item.structure === this.selectedStructure
              );
              if (startIndex !== -1) {
                filteredData = filteredData.slice(startIndex, startIndex + 10);
              } else {
                filteredData = [];
              }
            }

            // 根据券商筛选
            if (this.selectedBrokerage !== 'all') {
              filteredData = filteredData.filter(
                (item) => item[this.selectedBrokerage] !== 0
              );
            }

            // 根据时间筛选（新增）
            if (this.selectedTimes !== 'all') {
               filteredData = filteredData.filter(item => item.term === this.selectedTimes);
            }

            return filteredData;
    }

  },
  methods: {
    applyPrice() {
      // 根据 selectedStructure_amount 计算倍数
      const selectedOption = this.total_principal_options.find(option => option.value === this.selectedStructure_amount);

      this.total_principal = selectedOption.value;
      this.total_principal_label = selectedOption.label;  // 直接使用 this.total_principal_label
      this.tableData = this.originalTableData.map(item => {
        return {
          ...item,
          银河_雪球: item.银河_雪球 * this.total_principal,
          中信_雪球: item.中信_雪球 * this.total_principal,
          浙期_雪球: item.浙期_雪球 * this.total_principal,
          国君_雪球: item.国君_雪球 * this.total_principal,
          中金_雪球: item.中金_雪球 * this.total_principal
        };
      });
      this.tableData[0].total_principal_label = this.total_principal_label;
    },
    async fetchData(searchData) {
  // 从 SearchForm 接收包含 query 和 date 的对象
  const { query, date } = searchData;

  if (this.isSubmitting) return;
  console.log('开始请求数据:', query);
  this.isSubmitting = true;
  try {
     // 构建请求参数，只添加存在的参数
        const params = {
          code: query
        };

        // 如果有日期则添加日期参数
        if (date) {
          params.now_date = date;
        }
    const response = await axios.get(`/api/query_xq`, {
      params,
      headers: {
        'Authorization': `Bearer ${this.$store.getters.token}`
      },
    });
    const responseData = response.data;
    if (responseData.stock_data_list != null) {
      this.data = responseData;

      this.tableData = this.generateTableData();
      this.originalTableData = [...this.tableData];
      this.containerDisplay = false;
    } else {
      this.data = {};
      this.$message.error(responseData.error || '不是两融标的');
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.detail) {
      if (error.response.data.detail.includes('无法验证凭证')) {
        this.$store.dispatch('logout');
        this.$router.push('/login');
      }
      this.$message.error(error.response.data.detail);
    } else {
      this.$message.error(this.data?.error || '请求失败');
    }
  } finally {
    this.isSubmitting = false;
    console.log('请求完成');
  }
},

    generateTableData() {
       const {stock_data_list } = this.data;
       const tableData = [
        // ... 你的 tableData 生成逻辑 ...
        { angry_name: '银河_雪球',structure: '不追保雪球', term: '6M',...this.extractValues(stock_data_list, '银河_雪球',[2,3,4,5,6,7,8,9]) },
        { angry_name: '中信_雪球', structure: ' ',term: '6M', ...this.extractValues(stock_data_list, '中信_雪球', [20,21,22,23,24,25,26,27]) },
        { angry_name: '中金_雪球', structure: ' ',term: '6M', ...this.extractValues(stock_data_list, '中金_雪球', [99,99,99,99,99,99,99,99]) },
        { angry_name: '浙期_雪球',  structure: ' ',term: '6M',...this.extractValues(stock_data_list, '浙期_雪球', [99,99,5,2,6,3,7,4]) },
        { angry_name: '国君_雪球',  structure: ' ',term: '6M',...this.extractValues(stock_data_list,'国君_雪球',  [99,99,99,99,99,14,19,13]) },

           // ... 你的 tableData 生成逻辑 ...
        { angry_name: '银河_雪球',structure: '不追保雪球', term: '12M',...this.extractValues(stock_data_list, '银河_雪球',[10,11,12,13,14,15,16,17]) },
        { angry_name: '中信_雪球', structure: ' ',term: '12M', ...this.extractValues(stock_data_list, '中信_雪球', [28,29,30,31,32,33,34,35]) },
        { angry_name: '中金_雪球', structure: ' ',term: '12M', ...this.extractValues(stock_data_list, '中金_雪球', [99,99,99,99,99,99,99,99]) },
        { angry_name: '浙期_雪球',  structure: ' ',term: '12M',...this.extractValues(stock_data_list, '浙期_雪球', [11,8,12,9,13,10,99,99]) },
        { angry_name: '国君_雪球',  structure: ' ',term: '12M',...this.extractValues(stock_data_list,'国君_雪球',  [22,17,21,16,20,15,99,99]) },


        // ... 你的 tableData 生成逻辑 ...
        { angry_name: '银河_雪球',structure: '追保雪球',term: '6M',...this.extractValues(stock_data_list, '银河_雪球',[18,19,20,21,22,23,24,25]) },
        { angry_name: '中信_雪球', structure: ' ', term: '6M',...this.extractValues(stock_data_list, '中信_雪球', [3,4,5,6,7,8,9,10]) },
        { angry_name: '中金_雪球', structure: ' ',term: '6M', ...this.extractValues(stock_data_list, '中金_雪球', [99, 99, 99, 99, 99, 99, 99, 99]) },
        { angry_name: '浙期_雪球',  structure: ' ',term: '6M',...this.extractValues(stock_data_list, '浙期_雪球', [99, 99, 5,2,6,3,7,4]) },
        { angry_name: '国君_雪球',  structure: ' ',term: '6M',...this.extractValues(stock_data_list,'国君_雪球',  [99, 99,17,15,18,15,19,16]) },


        { angry_name: '银河_雪球',structure: '追保雪球',term: '12M',...this.extractValues(stock_data_list, '银河_雪球',[26,27,28,29,30,31,32,33]) },
        { angry_name: '中信_雪球', structure: ' ',term: '12M', ...this.extractValues(stock_data_list, '中信_雪球', [11,12,13,14,15,16,17,19]) },
        { angry_name: '中金_雪球', structure: ' ', term: '12M',...this.extractValues(stock_data_list, '中金_雪球', [99, 99, 99, 99, 99, 99, 99, 99]) },
        { angry_name: '浙期_雪球',  structure: ' ',term: '12M',...this.extractValues(stock_data_list, '浙期_雪球', [99, 99, 5,2,6,3,7,4]) },
        { angry_name: '国君_雪球',  structure: ' ',term: '12M',...this.extractValues(stock_data_list,'国君_雪球',  [23,20,24,21,25,22,99,99]) },

         // ... 你的 tableData 生成逻辑 ...
        { angry_name: '银河_雪球',structure: '折价建仓雪球',term: '6M',...this.extractValues(stock_data_list, '银河_雪球',[99,99,99,99,99],'折价建仓雪球') },
        { angry_name: '中信_雪球', structure: '',term: '6M', ...this.extractValues(stock_data_list, '中信_雪球', [37,38,39,40,41,42],'折价建仓雪球') },
        { angry_name: '中金_雪球', structure: '',term: '6M', ...this.extractValues(stock_data_list, '中金_雪球', [99,99,99,99,99],'折价建仓雪球') },
        { angry_name: '浙期_雪球',  structure: '',term: '6M',...this.extractValues(stock_data_list, '浙期_雪球', [99,99,99,99,99],'折价建仓雪球') },
        { angry_name: '国君_雪球',  structure: '',term: '6M',...this.extractValues(stock_data_list,'国君_雪球',  [23, 24, 25, 26, 27],'折价建仓雪球') },


        { angry_name: '银河_雪球',structure: '折价建仓雪球',term: '12M',...this.extractValues(stock_data_list, '银河_雪球',[99,99,99,99,99],'折价建仓雪球') },
        { angry_name: '中信_雪球', structure: '',term: '12M', ...this.extractValues(stock_data_list, '中信_雪球', [43,44,45,46,47,48],'折价建仓雪球') },
        { angry_name: '中金_雪球', structure: '',term: '12M', ...this.extractValues(stock_data_list, '中金_雪球', [99,99,99,99,99],'折价建仓雪球') },
        { angry_name: '浙期_雪球',  structure: '',term: '12M',...this.extractValues(stock_data_list, '浙期_雪球', [99,99,99,99,99],'折价建仓雪球') },
        { angry_name: '国君_雪球',  structure: '',term: '12M',...this.extractValues(stock_data_list,'国君_雪球',  [28, 29, 30, 31, 32, 33, 34],'折价建仓雪球') }
      ];
      return tableData;

   },
   extractValues(stock_data_list,name, indices,selectedStructure='雪球') {
      let terms = ['70-100','70-103','75-100','75-103','80-100','80-103','85-100','85-103'];
      if (selectedStructure === '折价建仓雪球') {
           terms = ['70-100-80','70-103-80','75-100-85','75-103-85','80-100-90','80-103-90'];
      }
        const values = {};
        terms.forEach((term, index) => {
          values[term] = stock_data_list[name]?.[indices[index]] || 0;
        });
      return values;
    },
    applyBrokerageFilter() {
      // 这个方法在 computed 中的 filteredTableData 已经处理了
    }
  }
}
</script>
<styled>
.el-input__wrapper{
padding: 0;
}

</styled>

